import React from "react";
import { Link, useLocation } from "react-router-dom";
import const_config from "../../utility/config/const_config";
import { landingAsset } from "../utils/landingAsset";
import "../sass/MottruckLanding.scss";

/** Exact SVGs from index.dc.html footer */
const IconYouTube = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="#1A244D" aria-hidden="true">
    <path d="M23 7.2s-.2-1.6-.9-2.3c-.9-.9-1.9-.9-2.3-1C16.9 3.6 12 3.6 12 3.6h0s-4.9 0-7.8.3c-.5 0-1.5.1-2.3 1-.7.7-.9 2.3-.9 2.3S.7 9.1.7 11v1.9c0 1.9.3 3.8.3 3.8s.2 1.6.9 2.3c.9.9 2 .9 2.5 1 1.8.2 7.6.3 7.6.3s4.9 0 7.8-.3c.5 0 1.5-.1 2.3-1 .7-.7.9-2.3.9-2.3s.3-1.9.3-3.8V11c0-1.9-.3-3.8-.3-3.8zM9.7 14.9V8.4l6.3 3.3-6.3 3.2z" />
  </svg>
);

const IconInstagram = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1A244D" strokeWidth="1.8" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" />
    <circle cx="12" cy="12" r="4.5" />
    <circle cx="17.2" cy="6.8" r="1" fill="#1A244D" stroke="none" />
  </svg>
);

const IconLinkedIn = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="#1A244D" aria-hidden="true">
    <path d="M4.98 3.5C4.98 4.9 3.9 6 2.5 6S0 4.9 0 3.5 1.1 1 2.5 1s2.48 1.1 2.48 2.5zM.5 8.5h4V23h-4V8.5zM8.5 8.5h3.8v2h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V23h-4v-6.85c0-1.63-.03-3.73-2.27-3.73-2.28 0-2.63 1.78-2.63 3.62V23h-4V8.5z" />
  </svg>
);

const Footer = () => {
  const path = useLocation().pathname;
  const show = const_config.show_header_footer_paths.includes(path);
  if (!show) return null;

  return (
    <footer className="mtk-site-footer">
      <div className="inner">
        <div className="brand-col">
          <Link to="/" className="brand-logo">
            <img src={landingAsset("mottruck-logo-lockup.svg")} alt="Mottruck" />
          </Link>
          <div className="socials">
            <a href="https://www.youtube.com/@Mottruck" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <IconYouTube />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <IconInstagram />
            </a>
            <a href="https://www.linkedin.com/company/mottruck/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <IconLinkedIn />
            </a>
          </div>
        </div>

        <div>
          <h4>Contact</h4>
          <div className="contact-txt">
            contact@mottruck.com
            <br />
            3 rue d&apos;Enghien
            <br />
            75010, Paris – France
          </div>
        </div>

        <div>
          <h4>Solutions</h4>
          <div className="links">
            <Link to="/solutions">Shipper</Link>
            <Link to="/solutions/carrier">Carrier</Link>
          </div>
        </div>

        <div>
          <h4>Resources</h4>
          <div className="links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>

      <div className="bottom-rule" />
      <div className="copy">Copyright © 2026 Mottruck | All Rights Reserved</div>
    </footer>
  );
};

export default Footer;
